import PropTypes from 'prop-types';
import React, { useId } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconLogo = ({ className, branding }) => {
    const gradientId = useId();

    let colourOne = null;
    let colourTwo = null;
    let colourThree = null;

    switch (branding) {
    case 'SOLAR':
        colourOne='#F39300';
        colourTwo='#FEDC05';
        break;
    case 'LOCAL_GLOBE':
        colourOne='#1D9BF0';
        colourTwo='#FBDB08';
        break;
    case 'LATITUDE':
        colourOne='#008B36';
        colourTwo='#FEDC05';
        break;
    case 'BASECAMP':
        colourOne='#ED5352';
        colourTwo='#EC529A91';
        colourThree ='#FEDC05';
        break;
    case 'PHOENIX_COURT_WORKS':
        colourOne ='#602482';
        colourTwo='#FEDC05';
        break;
    default:
        colourOne='#E10A7C';
        colourTwo='#FEDC05';
        break;
    }

    return (
        <svg
            className={'icon-logo' + (className ? ` ${className}` : '')}
            fill='none'
            viewBox='0 0 39 46'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M28.548 28.862c2.064 1.235 2.331 1.33 3.363 1.33 1.605 0 3-1.292 3-2.774 0-1.54-1.185-2.68-4.796-4.465-3.363-1.691-4.185-2.66-4.185-5.036 0-2.926 1.395-4.16 5.828-5.13.306-.057.822-.152 1.49-.36-4.7-.97-6.305-2.566-6.305-6.309L27 4.58v-.418c0-2.318-.459-3.135-1.7-3.135-2.007 0-3.364 2.68-3.364 6.631V24.91l6.612 3.952ZM16.47 46l-.42-1.121c-1.3-4.047-1.605-5.34-2.16-8.93-.152-1.026-.305-2.261-.515-3.743l-.153-1.178c-3.306-1.482-5.427-2.204-6.459-2.204-1.299 0-2.063 1.026-2.37 3.135h-.458c.363-5.605 3.459-9.444 7.529-9.444.42 0 .879 0 1.49.058l-.095-10.109c-.057-5.073-.478-7.334-1.605-9.025-.784-1.178-2.121-1.9-3.612-1.9-2.12 0-3.821 1.292-3.821 2.831 0 .817.458 1.482 1.7 2.356L7.07 7.904c2.847 2.11 3.726 3.534 3.726 6.004 0 4.01-2.847 7.03-7.7 8.17v-.456c3-1.026 3.879-1.634 3.879-2.622 0-.665-.42-1.026-1.548-1.596C1.815 15.77 0 13.148 0 9.804 0 4.104 4.548.247 11.255.247c3.305 0 6.344.931 8.102 2.47.783.665 1.127 1.235 1.968 2.622C22.567 1.482 24.515 0 28.662 0c4.49 0 7.185 2.052 7.185 5.434 0 .817-.095 1.634-.363 2.622l-.306 1.292a4.65 4.65 0 0 0-.152 1.121c0 1.482.573 1.995 2.159 1.995.516 0 .821 0 1.815-.152v.57l-.726.095-2.484.21c-2.217.151-3.249.512-3.249 1.234 0 .513.42.817 3 1.9 2.274.97 3.249 2.204 3.249 4.256 0 4.161-2.733 8.93-6.917 12.218-2.332 1.805-4.338 2.622-6.306 2.622-1.09 0-2.37-.418-4.433-1.444-.516 2.47-.822 3.743-2.064 7.334-.822 2.47-.974 2.983-1.7 4.674h-.899V46Z'
                fill={`url(#${gradientId})`} />
            <defs>
                <linearGradient
                    gradientUnits='userSpaceOnUse'
                    id={gradientId}
                    x1='19.5'
                    x2='19.5'
                    y1='0'
                    y2='46'>
                    <stop
                        stopColor={colourOne}/>
                    <stop
                        offset='1'
                        stopColor={colourTwo} />
                    {colourThree && (
                        <stop
                            offset='1'
                            stopColor={colourThree} />
                    )}
                </linearGradient>
            </defs>
        </svg>
    );
};
/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    branding: PropTypes.string,
};

IconLogo.propTypes = propTypes;

export default IconLogo;
